






















































import Vue, { PropOptions } from 'vue'
import {
  PRINT_METHODS,
  PRINTING_METHOD
} from '@/search/const'
import { PrintingMethodsCount } from '@/search/types'

import FilterItem from '@/search/components/FilterItem.vue'
import HeaderSection from '@/search/components/HeaderSection.vue'

export default Vue.extend({
  components: {
    FilterItem,
    HeaderSection
  },
  props: {
    initMethods: {
      type: Array,
      required: true
    } as PropOptions<string[]>,
    printingMethodsCount: {
      type: Object,
      required: true
    } as PropOptions<PrintingMethodsCount>
  },
  data(): {
    selectedMethods: Array<string>
    contentVisible: boolean
    printingMethodItems: Array<{ [key: string]: string }>
  } {
    return {
      selectedMethods: [],
      contentVisible: false,
      printingMethodItems: PRINTING_METHOD
    }
  },
  computed: {
    printMethods(): { [key: string]: string } {
      return PRINT_METHODS
    },
    selectedMethodLabel(): string {
      return this.selectedMethods.map(item => this.printMethods[item]).join('/')
    }
  },
  mounted() {
    this.selectedMethods = this.initMethods
  },
  methods: {
    toggleContent() {
      this.contentVisible = !this.contentVisible
    },
    methodCount(type: 'full' | 'single'): number {
      return this.printingMethodsCount[type]
    },
    onChangeSelection() {
      this.$emit('updateParams', {
        printingMethods: this.selectedMethods
      })
    }
  }
})
